module.exports = __webpack_public_path__ + "img/no-distributor-state.23b662b5.svg";